import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraEmptyState, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { resolveSharedTiers } from '../../../../../lib/utils/pricingEngine';
import { CPFFClinEditor } from './CPFFClinEditor';
import { FFPClinEditor } from './FFPClinEditor';
import { GenericClinEditor } from './GenericClinEditor';
import { ParameterField } from './ParameterField';
import { TMClinEditor } from './TMClinEditor';
import { TravelClinEditor } from './TravelClinEditor';
export function ClinEditor({ clinPricing: clin, rateCard, sharedTierConfigs, onChange, onNavigate, onSharedTierChange }) {
    const contract = clin.metadata.contractType?.toUpperCase() ?? '';
    const labor = clin.laborStructure;
    const resolved = labor.type === 'tiered_shared' ? {
        ...clin,
        laborStructure: resolveSharedTiers(labor, sharedTierConfigs)
    } : clin;
    const props = {
        clinPricing: resolved,
        rateCard,
        onChange: (next)=>{
            if (labor.type !== 'tiered_shared') {
                onChange(next);
                return;
            }
            if (JSON.stringify(next.feeMethod) !== JSON.stringify(clin.feeMethod)) onChange({
                ...clin,
                feeMethod: next.feeMethod
            });
            if (next.laborStructure.type === 'tiered') next.laborStructure.tiers.forEach((tier, index)=>{
                const config = sharedTierConfigs.find((c)=>c.id === labor.tierRefs[index]?.sharedTierConfigId);
                if (config && JSON.stringify(config.group) !== JSON.stringify(tier.group)) onSharedTierChange({
                    ...config,
                    group: tier.group
                });
            });
        }
    };
    const Editor = contract.includes('FFP') || contract.includes('FP') || contract === 'FIRM-FIXED-PRICE' ? FFPClinEditor : contract.includes('T&M') || contract.includes('TM') || contract.includes('LH') || [
        'TIME-AND-MATERIALS',
        'LABOR-HOUR'
    ].includes(contract) ? TMClinEditor : [
        'CPFF',
        'CPAF',
        'CPIF',
        'COST-PLUS'
    ].some((type)=>contract.includes(type)) ? CPFFClinEditor : GenericClinEditor;
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                title: `CLIN ${clin.clinNumber}`
            }),
            /*#__PURE__*/ _jsx(SpecraText, {
                children: clin.metadata.title
            }),
            clin.metadata.isNsp ? /*#__PURE__*/ _jsx(SpecraEmptyState, {
                title: "Not Separately Priced",
                description: `CLIN ${clin.clinNumber} is included in the price of another CLIN.`
            }) : clin.metadata.travelConfig ? /*#__PURE__*/ _jsx(TravelClinEditor, {
                ...props
            }) : labor.type === 'none' ? clin.volumeMethod.type === 'fixed_quantity' ? /*#__PURE__*/ _jsx(ParameterField, {
                label: `Amount per ${clin.volumeMethod.unit}`,
                param: clin.volumeMethod.quantity,
                editable: true,
                onChange: (value)=>{
                    if (clin.volumeMethod.type === 'fixed_quantity') onChange({
                        ...clin,
                        volumeMethod: {
                            ...clin.volumeMethod,
                            quantity: {
                                ...clin.volumeMethod.quantity,
                                value
                            }
                        }
                    });
                }
            }) : /*#__PURE__*/ _jsx(SpecraEmptyState, {
                title: "No editable fields for this CLIN type"
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    labor.type === 'tiered_shared' && labor.tierRefs.map((ref)=>/*#__PURE__*/ _jsxs(SpecraButton, {
                            variant: "secondary",
                            onClick: ()=>onNavigate(`tiers/${ref.sharedTierConfigId}`),
                            children: [
                                "Edit shared tier",
                                ' ',
                                sharedTierConfigs.find((tier)=>tier.id === ref.sharedTierConfigId)?.tierLabel ?? ref.sharedTierConfigId
                            ]
                        }, ref.sharedTierConfigId)),
                    /*#__PURE__*/ _jsx(Editor, {
                        ...props
                    })
                ]
            })
        ]
    });
}
